import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminAuth.css";

function AdminForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleReset = (e) => {
    e.preventDefault();

    const storedAdmin = JSON.parse(localStorage.getItem("admin"));

    if (!storedAdmin) {
      alert("No admin account found.");
      return;
    }

    if (email !== storedAdmin.email) {
      alert("Invalid email! Please enter registered email.");
      return;
    }

    const updatedAdmin = {
      ...storedAdmin,
      password: newPassword,
    };

    localStorage.setItem("admin", JSON.stringify(updatedAdmin));

    alert("Password updated successfully!");
    navigate("/admin");
  };

  return (
    <div className="admin-container">
    <div className="admin-card">
      <h2>Reset  Password</h2>

      <form onSubmit={handleReset}>
        <input
          type="email"
          placeholder="Registered Email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <br /><br />

        <input
          type="password"
          placeholder="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <br /><br />

        <button type="submit">Reset Password</button>
      </form>
    </div>
    </div>
  );
}

export default AdminForgotPassword;
